import _ from 'lodash'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import WidgetType from '@/modules/widget/model/WidgetType';

/**
 * Widget
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Widget {
    public id = 0
    public readonly tempId = _.uniqueId('widget_')
    public type: WidgetType
    public userId = 0
    public positionX = 0
    public positionY = 0
    public columnWidth = 0
    public columnHeight = 0
    public state: any = {}
    public typeName = ''

    /**
     * Crea una entidad a partir de la información plana recibida del servidor
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const widget = new this()
        widget.id = data.id
        widget.typeName = data.type
        widget.positionX = data.x_position
        widget.positionY = data.y_position
        widget.columnWidth = data.column_width
        widget.columnHeight = data.column_height

        if (Array.isArray(data.state) && data.state.length === 0) {
            widget.state = {}
        } else {
            widget.state = data.state
        }

        return widget
    }

    /**
     * Convierte la entidad a un objeto de datos planos
     */
    public serialize () {
        return {
            id: this.id,
            type: this.type.name,
            x_position: this.positionX,
            y_position: this.positionY,
            column_width: this.columnWidth,
            column_height: this.columnHeight,
        }
    }
}
